import { BehaviorSubject } from 'rxjs';

export const subjects = {
  csrfToken: new BehaviorSubject(),
  currentEntity: new BehaviorSubject(),
  // Parent chain of the current entity for breadcrumb padding on nested entities.
  // Value: { entity_id, ancestors: [...] } where ancestors run root -> immediate parent.
  // Keyed by entity_id so a stale response can't paint onto a different entity.
  currentEntityAncestors: new BehaviorSubject([]),
  currentCustomProperty: new BehaviorSubject(),
  currentConnection: new BehaviorSubject(),
  currentDataset: new BehaviorSubject(),
  // Parent chain of the current dataset for breadcrumb padding on nested datasets.
  // Value: { dataset_id, ancestors: [...] } where ancestors run root -> immediate parent.
  // Keyed by dataset_id so a stale response can't paint onto a different dataset.
  currentDatasetAncestors: new BehaviorSubject([]),
  currentDatasetGroup: new BehaviorSubject(),
  currentDatasource: new BehaviorSubject(),
  currentField: new BehaviorSubject(),
  currentAttribute: new BehaviorSubject(),
  // Parent chain of the current attribute for breadcrumb padding: the entity it hangs under and
  // everything above that entity, root -> immediate parent. An attribute is a leaf, so the chain is
  // entities only. Value: { attribute_id, ancestors: [...] }, keyed by attribute_id so a stale
  // response can't paint onto a different attribute.
  currentAttributeAncestors: new BehaviorSubject([]),
  currentAttributeValue: new BehaviorSubject(),
  currentGlossary: new BehaviorSubject(),
  currentJob: new BehaviorSubject(),
  currentSystem: new BehaviorSubject(),
  currentSchedule: new BehaviorSubject(),
  currentTask: new BehaviorSubject(),
  currentUser: new BehaviorSubject(),
  currentUserGroup: new BehaviorSubject(),
  isLoggedIn: new BehaviorSubject(false),
  loggedInUser: new BehaviorSubject({}),
  userSettings: new BehaviorSubject({}),
  settings: new BehaviorSubject([]),
  displayNames: new BehaviorSubject([]),
  statuses: new BehaviorSubject([]),
  attributeSensitivities: new BehaviorSubject([]),
};
